import * as React from 'react';

import PaginatedEntityTable from 'components/common/PaginatedEntityTable';
import QueryHelper from 'components/common/QueryHelper';
import usePluggableEntityTableElements from 'hooks/usePluggableEntityTableElements';
import { Col } from 'common/components';
import { useFetchEventProcedures } from 'security-app/hooks/useEventProceduresAPI';
import type { EventProceduresEntityType } from 'security-app/hooks/api/eventProceduresAPI.types';
import type { SearchParams } from 'stores/PaginationTypes';
import type { PaginatedResponse } from 'components/common/PaginatedEntityTable/useFetchEntities';
import { CurrentUserStore } from 'stores/users/CurrentUserStore';

import { useColumnRenderers } from './column-renderers';
import { listElements, deserializeEventProcedures, entityActionRender } from './constants';

import EventProcedureTabs from '../EventProcedureTabs';

type Props = {
  useCoreRoutes?: boolean;
};

function EventProcedureList({ useCoreRoutes = false }: Props) {
  const { columnRenderers } = useColumnRenderers();
  const { searchEventProcedures, eventProceduresEntitiesKeyFn } = useFetchEventProcedures(deserializeEventProcedures);
  const { pluggableExpandedSections }: any = usePluggableEntityTableElements<EventProceduresEntityType>(
    null,
    'event_procedure',
  );

  const fetchEntities = (options: SearchParams): Promise<PaginatedResponse<EventProceduresEntityType>> => {
    CurrentUserStore.update(CurrentUserStore.getInitialState().currentUser.username);

    return searchEventProcedures(options);
  };

  return (
    <Col $align="center">
      <PaginatedEntityTable<EventProceduresEntityType>
        humanName="Event Procedures"
        columnsOrder={listElements.columnOrder}
        queryHelpComponent={<QueryHelper entityName="Event Procedure" />}
        tableLayout={listElements.defaultLayout}
        fetchEntities={fetchEntities}
        keyFn={eventProceduresEntitiesKeyFn}
        entityActions={entityActionRender}
        entityAttributesAreCamelCase={false}
        columnRenderers={columnRenderers}
        topRightCol={<EventProcedureTabs viewType="procedures" useCoreRoutes={useCoreRoutes} />}
        expandedSectionsRenderer={pluggableExpandedSections}
      />
    </Col>
  );
}

export default EventProcedureList;
